import React, { useState } from "react";
import { useManageIPMSContext } from "./ManageIPMSContex";
import { ChevronUpIcon } from "@heroicons/react/24/outline";
// Interfaces for data (already defined above)
interface Goal {
  description: string;
}

interface AccordionItem {
  id: string;
  title: string;
  items: Goal[];
}

const Accordion: React.FC<{ items: AccordionItem[]}> = ({
  items,
}) => {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const toggleAccordion = (index: number) => {
    setOpenIndex((prevIndex) => (prevIndex === index ? null : index));
  };

  return (
    <div>
      {items.map((item, index) => (
        <div key={item.id} className='mb-2'>
          <h2 id={`${item.id}-heading`}>
            <button
              type='button'
              className='flex items-center justify-between w-full p-5 font-medium text-gray-800 border border-gray-200  bg-green-100 hover:bg-green-100  gap-0'
              onClick={() => toggleAccordion(index)}
              aria-expanded={openIndex === index}
              aria-controls={`${item.id}-body`}
            >
              <span className='flex items-center '>{item.title}</span>
              <ChevronUpIcon className={`w-5 h-5 ${openIndex === index? "rotate-180" : ""} shrink-0`} />
            </button>
          </h2>
          <div
            id={`${item.id}-body`}
            className={`p-5 border border-t-0 border-gray-200 dark:border-gray-700 ${
              openIndex === index ? "block" : "hidden"
            }`}
            aria-labelledby={`${item.id}-heading`}
          >
            <ul className='list-disc ps-5  text-gray-600 dark:text-gray-300'>
              {item.items.map((goal, idx) => (
                <li key={idx} className='py-1 text-sm'>
                  {/* {goal.description} */}
                  {goal.description.split("\\r\\n").map((line, index) => (
                    <React.Fragment key={index}>
                      <p className='py-0.5'>{line}</p>
                    </React.Fragment>
                  ))}
                </li>
              ))}
            </ul>
          </div>
        </div>
      ))}
    </div>
  );
};

const GoalsAccordianPage: React.FC = () => {
  const { GetIpmsEmployeeData } = useManageIPMSContext();

  // console.log('GetIpmsEmployeeData ===> ', GetIpmsEmployeeData)
  
  const quarter1 = GetIpmsEmployeeData?.quarters?.['1'];

  const items: AccordionItem[] = [
    {
      id: "org-goals",
      title: "Organizational Goals",
      items: quarter1?.org?.map((item) => ({ description: item.kra })) ?? [],
    },
    {
      id: "soft-goals",
      title: "Soft Goals",
      items: quarter1?.soft?.map((item) => ({ description: item.kra })) ?? [],
    },
  ];

  return (
    <div className='mb-10'>
      <Accordion items={items} />
    </div>
  );
};

export default GoalsAccordianPage;
